import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => ({
  container: {
    ...theme.typography,
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  },
  storeSelect: {
    marginBottom: theme.spacing(2)
  },
  productSelectItemName: {
    fontSize: 14
  },
  productSelectItemPrice: {
    fontSize: 12,
    textAlign: "right"
  },
  productSelectItemSize: {
    fontSize: 11,
    color: theme.palette.grey[400]
  },
  selectedItemName: {
    marginTop: 0,
    marginBottom: theme.spacing(1),
    fontSize: 16
  },
  selectedItemInput: {
    display: "flex"
  },
  selectedItemPriceContainer: {
    flex: 2
  },
  selectedItemPrice: {
    fontSize: 11
  },
  selectedItemQuantity: {
    flex: 4,
    maxWidth: 50
  },
  inputs: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1)
  },
  total: {
    marginTop: theme.spacing(4),
    fontSize: 16,
    fontWeight: theme.typography.fontWeightBold
  },
  saveButton: {
    margin: theme.spacing(2),
    position: "fixed",
    bottom: 0,
    right: 0
  }
}));
